import React from "react";
 import profile from "assets/images/hfprofile.svg";
import TextField from "components/textfield";
import SelectDropdown from "components/selectfield";
import PhoneField from "components/phone-number-input";
import Button from "components/button";

export default function Mobile() {
  return (
    <div className="w-full flex items-center justify-center">
      <div className="w-[100%] h-[90%] shadow-[0_30px_50px_-15px_rgba(0,0,0,0.3)] rounded-lg border border-[#DDDDDD] flex items-center justify-start flex-col gap-[10px]">
        <div className="w-[85%] py-[10px] flex flex-col items-start justify evenly border-b border-[#DDDDDD]">
          <h1 className="text-[25px] font-medium">Update Hf Profile</h1>
          <p className="text-[14px] font medium">
            Enter your new profile details
          </p>
        </div>
        <div className="w-[85%] py-3 flex flex-col items-center justify-between">
          <div className="w-[100%] h-[200px] mb-[5px] rounded-lg">
            <img
              src={profile}
              alt=""
              className="w-[100%] h-[100%] object-cover"
            />
          </div>
          <div className="w-[100%] flex flex-col gap-4">
            <TextField label="Name of Health Facility" value={""} />
            <TextField label="Company Email" value={""} />
          <TextField label="Location" value={""} /> 
           <TextField label="Opening hour" value={""} type="time" />
            <TextField label="Closing hour" value={""} type="time" />
            <TextField label="Address of Health Facility" value={""} />
            <SelectDropdown label="Date Of Birth" options={[]} value={""} />
            <PhoneField label="Phone Number" value={""} />
            <PhoneField label="Whatsapp Number" value={""} />
            <Button fullWidth label="Update Profile" /> 
          </div>
        </div>
      </div>
    </div>
  );
}